import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

//actions
import { postUpdated, updateFilterSelected } from '../actions';

class ShowMore extends Component {
  
  render() {
    return (
      <div onClick={() => this.props.handleClick()} className={`${this.props.showMoreVisibility} show-more btn-bw-mustard btn-bw-mustard-plus`}>
        Show More
      </div>
    );
  }
}

ShowMore.propTypes = {
  data: PropTypes.array
};

const mapDispatchToProps = dispatch => {
  return {
    postUpdated: (sortBy, value, filteredData, filterSelected) =>
      dispatch(postUpdated(sortBy, value, filteredData, filterSelected)),
    updateFilterSelected: (filtername, value) => dispatch(updateFilterSelected(filtername, value))
  };
};

const mapStateToProps = state => {
  return {
    type: state.postData.type,
    filteredData: state.postData.filteredData,
    data: state.postData.data,
    filters: state.filters
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowMore);
